<div class="criteria-container p-3">
    <div class="row">
        <div class="col-3">
            <form novalidate [formGroup]="reportSelectForm">
                <label translate>ReportsCriteria.ReportSelectLabel</label>
                <bcu-drop-down-cf2 [selectAll]="false"
                    placeHolder="{{ 'ReportsCriteria.ReportSelectPlaceholder' | translate }}" [multiple]="false"
                    [options]="reports" displayKey="name" valueKey="id" formControlName="report" [sortItems]="true"></bcu-drop-down-cf2>
            </form>
        </div>
        <div class="col-4"></div>
        <div class="col-3 text-right">
                <button class="btn btn-success"
                    [hidden]="!isAdpExtractVisible"
                    translate
                    [disabled]="generateDisabled"
                    (click)="generateAdpExtractFile()">
                    ReportsCriteria.GenerateADPExtractButton
                </button>
            </div>
        <div class="col-2">
            <button class="btn btn-success" translate [disabled]="generateDisabled" (click)="generateReportFile()">
                ReportsCriteria.GenerateFileButton
            </button>
        </div>
    </div>
    <form novalidate [formGroup]="form" (ngSubmit)="showReport()">
        <div class="row">
            <div class="col-2" *ngIf="showOnlineContentTypeFilter">
                <label translate>ReportsCriteria.LableOnlineContentView</label>
                <bcu-drop-down-cf2 [isDisabled]="noReportSelected"
                    formControlName="contentType" [options]="contentTypes"
                    valueKey="code" displayKey="name" [maxHeigth]="400" [sortItems]="true"
                    placeHolder="{{ 'OnlineContentViewReport.All' | translate }}">
                </bcu-drop-down-cf2>
            </div>
            <div class="col-2" *ngIf="showDatesFilter">
                <label translate>ReportsCriteria.LabelDateFrom</label>
                <bcu-drop-down-button-cf2 [text]="form.controls['dateFrom'].value | bcDate"
                    (click)="dateFromPicker.toggle($event)" [readonly]="noReportSelected">
                </bcu-drop-down-button-cf2>
                <bcu-date-select [readonly]="noReportSelected" [canSelectPastDates]="true"
                    [canSelectFutureDates]="false" [canSelectToday]="false" #dateFromPicker formControlName="dateFrom">
                </bcu-date-select>
            </div>
            <div class="col-2" *ngIf="showDatesFilter">
                <label translate>ReportsCriteria.LabelDateTo</label>
                <bcu-drop-down-button-cf2 [text]="form.controls['dateTo'].value | bcDate"
                    (click)="dateToPicker.toggle($event)" [readonly]="noReportSelected">
                </bcu-drop-down-button-cf2>
                <bcu-date-select [readonly]="noReportSelected" [canSelectPastDates]="true"
                    [canSelectFutureDates]="false" [canSelectToday]="false" #dateToPicker formControlName="dateTo">
                </bcu-date-select>
            </div>
            <div class="col-4" *ngIf="showPayPeriodFilter">
                <label translate >ReportsCriteria.PayPeriod</label>
                <bcu-drop-down-cf2  [selectAll]="false"
                    [multiple]="false" [options]="payPeriods"  valueKey="id"
                    displayKey="label" [maxHeigth]="400"  formControlName="payPeriod">
                </bcu-drop-down-cf2>
            </div>
            <div class="col-2" *ngIf="showClubFilter">
                <label translate *ngIf="showInstructorHomeClubLabel">ReportsCriteria.LabelInstructorsHomeClub</label>
                <label translate *ngIf="!showInstructorHomeClubLabel">ReportsCriteria.LabelClub</label>
                <bcu-drop-down-cf2 [isDisabled]="noReportSelected" [selectAll]="shouldFilterMultipleClubs"
                    placeHolder="{{ shouldFilterMultipleClubs ? ('ReportsCriteria.AllClubsPlaceholder' | translate) : ('ReportsCriteria.SelectClubPlaceholder' | translate) }}"
                    [multiple]="shouldFilterMultipleClubs" [options]="clubs" formControlName="clubs" valueKey="id"
                    displayKey="shortName" [maxHeigth]="400" [sortItems]="true">
                </bcu-drop-down-cf2>
            </div>
            <div class="col-2" *ngIf="showClassTypeFilter">
                <label translate>ReportsCriteria.LabelClassType</label>
                <bcu-drop-down-cf2 [isDisabled]="noReportSelected" [selectAll]="true"
                    [selectAllAsNone]="true"
                    placeHolder="{{ 'ReportsCriteria.ClassTypePlaceHolder' | translate }}"
                    [multiple]="false" [options]="classTypes" formControlName="classType" valueKey="id"
                    displayKey="name" [maxHeigth]="400" [sortItems]="true">
                </bcu-drop-down-cf2>
            </div>
            <div class="col-2" *ngIf="shouldShowInstructorsFilter">
                <label translate>ReportsCriteria.LabelInstructor</label>
                <bcu-drop-down-cf2 [isDisabled]="noReportSelected" [selectAll]="true"
                    placeHolder="{{ 'ReportsCriteria.AllInstructorsPlaceholder' | translate }}" [multiple]="true"
                    [options]="instructors" formControlName="instructors" valueKey="id" displayKey="name"
                    [maxHeigth]="400" [dropDownWidth]="300" [sortItems]="true">
                </bcu-drop-down-cf2>
            </div>
            <div class="col-2" *ngIf="showClassFilter">
                <label translate>ReportsCriteria.LabelClass</label>
                <bcu-drop-down-cf2 [isDisabled]="noReportSelected" [selectAll]="false"
                    placeHolder="{{ 'ReportsCriteria.SelectClassNamePlaceholder' | translate }}" [multiple]="false"
                    [options]="classes" formControlName="className" valueKey="id" displayKey="name" [maxHeigth]="400"
                    [dropDownWidth]="300" [sortItems]="false">
                </bcu-drop-down-cf2>
            </div>
            <div class="col-2" *ngIf="!showClassFilter"></div>
        </div>
        <div class="row" *ngIf="form.errors">
            <div class="col">
                <div translate class="red">ReportsCriteria.DateFromBiggerThanDateToError</div>
            </div>
        </div>
    </form>
</div>
